import { observer } from "mobx-react";
import MainLayout from "newApp/components/layouts/MainLayout";
import NewsList from "newApp/components/NewsList";
import NewsNavigator from "newApp/components/NewsNavigator";
import SiteNavigator from "newApp/components/SiteNavigator";
import Button from "newApp/kit/components/Button";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import LoaderSpinner from "newApp/kit/components/LoaderSpinner";
import Pagination from "newApp/kit/components/Pagination";
import { URL_SITE_NEWS_CREATE } from "newApp/routing/urls";
import { NewsPageStore } from "newApp/stores/pages/site/news/NewsPageStore";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const store = new NewsPageStore();

const NewsPage: React.FC = () => {
  const { push } = useHistory();

  useEffect(() => {
    store.init();
    return () => store.reset();
  }, []);

  return (
    <MainLayout>
      <H1>Новости</H1>
      <FlexColumn>
        <SiteNavigator />
        <NewsNavigator />
        <Button onClick={() => push(URL_SITE_NEWS_CREATE)}>
          Добавить новость
        </Button>
        {store.isLoading ? <LoaderSpinner /> : <NewsList {...store} />}
        <Pagination {...store.pagination} />
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(NewsPage);
